__turbopack_context__.v({
  "bookNavigation": "friendBook-module-scss-module__SyF55G__bookNavigation",
  "capiImage": "friendBook-module-scss-module__SyF55G__capiImage",
  "container": "friendBook-module-scss-module__SyF55G__container",
  "content": "friendBook-module-scss-module__SyF55G__content",
  "cover": "friendBook-module-scss-module__SyF55G__cover",
  "coverLeft": "friendBook-module-scss-module__SyF55G__coverLeft",
  "coverMiddle": "friendBook-module-scss-module__SyF55G__coverMiddle",
  "coverRight": "friendBook-module-scss-module__SyF55G__coverRight",
  "flipbook": "friendBook-module-scss-module__SyF55G__flipbook",
  "flipbookContainer": "friendBook-module-scss-module__SyF55G__flipbookContainer",
  "friendBookIntro": "friendBook-module-scss-module__SyF55G__friendBookIntro",
  "image": "friendBook-module-scss-module__SyF55G__image",
  "image2": "friendBook-module-scss-module__SyF55G__image2",
  "image3": "friendBook-module-scss-module__SyF55G__image3",
  "imageContainer": "friendBook-module-scss-module__SyF55G__imageContainer",
  "layersLeft": "friendBook-module-scss-module__SyF55G__layersLeft",
  "layersRight": "friendBook-module-scss-module__SyF55G__layersRight",
  "left": "friendBook-module-scss-module__SyF55G__left",
  "page": "friendBook-module-scss-module__SyF55G__page",
  "questions": "friendBook-module-scss-module__SyF55G__questions",
  "right": "friendBook-module-scss-module__SyF55G__right",
  "round": "friendBook-module-scss-module__SyF55G__round",
  "row": "friendBook-module-scss-module__SyF55G__row",
  "template-animals": "friendBook-module-scss-module__SyF55G__template-animals",
  "template-dinosaur": "friendBook-module-scss-module__SyF55G__template-dinosaur",
  "template-mariokart": "friendBook-module-scss-module__SyF55G__template-mariokart",
  "template-marvel": "friendBook-module-scss-module__SyF55G__template-marvel",
  "template-princesses": "friendBook-module-scss-module__SyF55G__template-princesses",
  "template-universe": "friendBook-module-scss-module__SyF55G__template-universe",
  "tile": "friendBook-module-scss-module__SyF55G__tile",
});
